<template>
    <div :id="id" ref="splideGallery" class="gallery__slider splide splide--gallery">
        <div class="splide__track">
            <ul class="splide__list">
                <li :key="image.id" v-for="image in images" class="splide__slide">
                    <div class="splide__img-wrapper">
                        <img :src="image.url" :alt="image.title" />
                    </div>
                    <div class="splide__body">
                        <h3>{{ image.title }}</h3>
                        <a v-if="image.assetLink != ''" :href="image.assetLink" class="button button--primary">Explore Range</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide';
import { EventBus } from './EventBus'

export default {
    props: {
		id: String,
		images: Array
    },
	data() {
		return {
            slider: null
        }	
	},
    mounted: function() {
        this.$nextTick(function() {
            this.slider = new Splide(document.getElementById(this.id), {
                updateOnMove: true,
                arrows: true,
                type   : 'loop',
                padding: '25%',
                gap: '2rem',
                speed: 500,
                breakpoints: {
                    640: {
                        padding: '0',
                        dots: false,
                    },
                }
            }).mount()
        })
    },
    created() {
        EventBus.$on('gallery-changed', () => {
            this.$nextTick(function() {
                this.slider.emit('resize')
            })       
        })
    }
}
</script>